var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AddBtnCallC"},[_c('Svgs',{attrs:{"color":_vm.color,"classes":"AddBtnCall","name":"icontianjia2"},nativeOn:{"click":function($event){return _vm.addCall.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }